module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAACCAYAAAD8bERYAAAAAXNSR0IArs4c6QAAADJJREFUKFNj/P///38GKGBkZGT8//+/MYjLyMh4FkTjkofpoQfNyMBwhhx7QJ4Ztp4DAFhhH/2S+oVtAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/xin_zeng.png
// module id = RuMV
// module chunks = 2